<div class="ivr-instance-page">
  <app-ivr-instance-toolbar (add)="openAddModal()" />

  <app-ivr-instance-list
    [instances]="instances"
    [loading]="loading"
    (edit)="openEditModal($event)"
    (delete)="openDeleteModal($event)" />

  <app-ivr-instance-form
    *ngIf="showFormModal"
    [visible]="true"
    [isEdit]="isEditMode"
    [instance]="selectedInstance"
    (visibleChange)="onFormVisibilityChange($event)"
    (saved)="onFormSaved($event)" />
</div>
